import { createAction, createAsyncAction } from "typesafe-actions";

import type { BenchmarkMetricName, MetaDataEntity, MetricEntity } from "app/pages/benchmark-tracker/types/api.types";

export const initMetricData = createAction("@@benchmark-tracker/report/initMetricData")<Record<string, MetricEntity>>();
export const addMetricData = createAction("@@benchmark-tracker/report/addMetricData")<Record<string, MetricEntity>>();

export const getMetrics = createAsyncAction(
    "@@benchmark-tracker/report/getAllMetrics/request",
    "@@benchmark-tracker/report/getAllMetrics/success",
    "@@benchmark-tracker/report/getAllMetrics/failure",
)<void, void, unknown>();

export const setIsLoadingManually = createAction("@@benchmark-tracker/report/setIsLoadingManually")<boolean>();

export const getMetaData = createAsyncAction(
    "@@benchmark-tracker/report/getGAMetaData/request",
    "@@benchmark-tracker/report/getGAMetaData/success",
    "@@benchmark-tracker/report/getGAMetaData/failure",
)<void, MetaDataEntity, unknown>();

export const getCompetitors = createAsyncAction(
    "@@benchmark-tracker/report/getCompetitors/request",
    "@@benchmark-tracker/report/getCompetitors/success",
    "@@benchmark-tracker/report/getCompetitors/failure",
)<void, { competitors: MetricEntity; metricName: BenchmarkMetricName }, unknown>();

export const getMetricItemImage = createAsyncAction(
    "@@benchmark-tracker/report/getAsset/image/request",
    "@@benchmark-tracker/report/getAsset/image/success",
    "@@benchmark-tracker/report/getAsset/image/failure",
)<void, Record<string, string>, unknown>();

export const resetImages = createAction("@@benchmark-tracker/report/set-is-images-fetched")();

export const setAudienceReachAutoDuration = createAction(
    "@@benchmark-tracker/report/set-audience-reach-duration",
)<string>();

export const downloadPdf = createAsyncAction(
    "@@benchmark-tracker/report/contextMenu/downloadPdf/request",
    "@@benchmark-tracker/report/contextMenu/downloadPdf/success",
    "@@benchmark-tracker/report/contextMenu/downloadPdf/failure",
)<void, void, unknown>();

export const subscribeToDigest = createAsyncAction(
    "@@benchmark-tracker/report/subscribeToDigest/request",
    "@@benchmark-tracker/report/subscribeToDigest/success",
    "@@benchmark-tracker/report/subscribeToDigest/failure",
)<void, void, unknown>();

export const unsubscribeFromDigest = createAsyncAction(
    "@@benchmark-tracker/report/unsubscribeFromDigest/request",
    "@@benchmark-tracker/report/unsubscribeFromDigest/success",
    "@@benchmark-tracker/report/unsubscribeFromDigest/failure",
)<void, void, unknown>();

export const openSubscriptionModal = createAction("@@benchmark-tracker/report/subscriptionModal/open")();
export const closeSubscriptionModal = createAction("@@benchmark-tracker/report/subscriptionModal/close")();
